import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e053c12e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prompts" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Prompt = _resolveComponent("Prompt")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "search",
      class: "w-full border-2 border-gray-300 p-1 rounded mb-4",
      placeholder: 'Search',
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
      onInput: _cache[1] || (_cache[1] = ev => _ctx.doSearch(ev.target?.value))
    }, null, 544), [
      [_vModelText, _ctx.search]
    ]),
    _createVNode(_component_List, {
      loading: _ctx.promptsLoading,
      items: _ctx.prompts,
      onAdd: _cache[3] || (_cache[3] = ({name, pos}) => _ctx.add(name, pos)),
      hideTopAdd: false,
      addInPos: _ctx.getters.isAdmin
    }, {
      default: _withCtx(({item}) => [
        (_openBlock(), _createBlock(_component_Prompt, {
          prompt: item,
          onUpdate: ({field, value}) => _ctx.edit(item, field, value),
          onDel: ($event: any) => (_ctx.del(item)),
          key: item.id
        }, null, 8, ["prompt", "onUpdate", "onDel"]))
      ]),
      add: _withCtx(() => [
        (_ctx.tab !== 'my')
          ? (_openBlock(), _createBlock(_component_Prompt, {
              key: 0,
              isNew: true,
              prompt: (_ctx.newPrompt as unknown as IPrompt),
              onAdd: _ctx.addItem,
              onUpdate: _cache[2] || (_cache[2] = ({field, value}) => _ctx.edit(_ctx.newPrompt as unknown as IPrompt, field, value))
            }, null, 8, ["prompt", "onAdd"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading", "items", "addInPos"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.needMore)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args))),
            disabled: _ctx.isLoading,
            class: "bg-green-300 px-2 block py-1 rounded mt-4 mx-auto"
          }, _toDisplayString(_ctx.isLoading ?'isLoading' : 'Load More'), 9, _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ]))
}